export const allFeaturesAtFalse = {
    home: {
        advantages: false,
        anchors: [],
    },
    certificates: {
        phyto: false,
        explosive: false,
    },
    contact: {
        mailTo: '',
    },
    shoppingList: false,
    header: {},
    footer: {
        sitemap: [],
    },
    pdp: {
        templateB2AGFeature: false,
    },
    equalWeb: false,
    checkoutV2: {
        displayRpd: false,
        displayMention: false,
        selectionByProducts: false,
    }
};
//# sourceMappingURL=default.js.map